import "./app.e0278e2b.js";
import "./app.48b2a3b9.js";
import "./feed.483da9e4.js";


function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire7903"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire7903"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("aEIUa", function(module, exports) {

$parcel$export(module.exports, "loadingIndicator", () => $7c2078fabb716a6f$export$f10e6b4aaa94c253);
/**
 * Show a loading state only when there is genuinely something to wait for.
 *
 * ── What was wrong ───────────────────────────────────────────────────────────
 *
 * The four pages that fetch their content shipped `<div id="loading">Loading…`
 * visible in the HTML, and hid it once the fetch resolved. That is right when
 * the fetch is slow and wrong the rest of the time, and the rest of the time is
 * most of the time.
 *
 * Measured on the live feed, on a repeat visit: `domContentLoaded` at 299ms,
 * the request for /api/v1/posts starting at 303ms and finishing at 305ms — two
 * milliseconds, served from the service worker's cache. The loader was on
 * screen from HTML parse until the module graph finished loading and running.
 * It was never waiting for data. It was waiting for JavaScript, with the answer
 * already in cache, and it flashed for roughly two hundred milliseconds every
 * single visit.
 *
 * ── What this does ───────────────────────────────────────────────────────────
 *
 * The element starts hidden in the markup, and is revealed only if the work is
 * still unfinished after a threshold. A fetch that resolves from cache never
 * reveals it; a cold visit, where the same request took over a second, does.
 *
 * That also fixes the announcement. These elements carry `role="status"` and
 * `aria-live="polite"`, so a screen reader announced "Loading…" on every visit
 * regardless. Now it is announced when it is true.
 *
 * ── On the threshold ─────────────────────────────────────────────────────────
 *
 * 250ms. Below roughly a tenth of a second a response reads as instant, and up
 * to a few tenths it reads as responsive; a spinner inside that window adds
 * noise and no information. Past it, silence starts to read as broken.
 *
 * It is deliberately not zero. A threshold of zero is the current behaviour
 * with extra steps.
 */ /** @type {number} */ const $7c2078fabb716a6f$var$DEFAULT_DELAY_MS = 250;
function $7c2078fabb716a6f$export$f10e6b4aaa94c253(element, delayMs = $7c2078fabb716a6f$var$DEFAULT_DELAY_MS) {
    if (!element) return ()=>{};
    element.hidden = true;
    const timer = setTimeout(()=>{
        element.hidden = false;
    }, delayMs);
    return ()=>{
        clearTimeout(timer);
        element.hidden = true;
    };
}

});

parcelRegister("70R4S", function(module, exports) {
module.exports = import.meta.resolve("dJajv");

});

parcelRegister("gxv0g", function(module, exports) {

$parcel$export(module.exports, "GOTRUE_API_URL", () => $c0a7c6fff4310ada$export$3993b1ab1ca0c3f1);
$parcel$export(module.exports, "initIdentityWidget", () => $c0a7c6fff4310ada$export$8c53c87b78e6fdd9);
$parcel$export(module.exports, "loadIdentityWidget", () => $c0a7c6fff4310ada$export$1259559fefbb46c);
$parcel$export(module.exports, "loadIdentityWidgetIfTokenPresent", () => $c0a7c6fff4310ada$export$267690839c122cee);
// Split out from auth-modal.js so pages with no sign-in UI (index, shows,
// studio) don't have to pull in the full custom auth modal — which builds
// and injects its whole login/signup DOM into the page as an import
// side-effect — just to initialize the Netlify Identity widget.
/**
 * This site's Identity (GoTrue) endpoint.
 *
 * Derived from wherever the page is served rather than hardcoded. The literal
 * production URL that used to live here meant a deploy preview authenticated
 * against production across origins — and, once this code is shared, that any
 * other band's deployment would silently sign users in against *this* band's
 * Identity instance.
 *
 * Locally this needs `netlify dev`, which serves /.netlify/identity on the dev
 * origin — the same thing the /api routes already require. Under a plain
 * `parcel serve` there is no Identity endpoint to talk to either way.
 */ const $c0a7c6fff4310ada$export$3993b1ab1ca0c3f1 = `${window.location.origin}/.netlify/identity`;
function $c0a7c6fff4310ada$export$8c53c87b78e6fdd9() {
    window.netlifyIdentity?.init({
        APIUrl: $c0a7c6fff4310ada$export$3993b1ab1ca0c3f1
    });
}
/**
 * The URL fragments Netlify Identity uses to hand a token to the page.
 *
 * These arrive from an email — confirm your address, reset your password,
 * accept an invite, confirm an address change. Visiting the link does not
 * confirm anything server-side; it drops the reader here with the token in the
 * hash, and only the initialised widget exchanges it for a session.
 */ const $c0a7c6fff4310ada$var$TOKEN_HASHES = [
    'confirmation_token=',
    'recovery_token=',
    'invite_token=',
    'email_change_token='
];
function $c0a7c6fff4310ada$export$d42ad5fbe912eace(hash = window.location.hash) {
    return $c0a7c6fff4310ada$var$TOKEN_HASHES.some((token)=>hash.includes(token));
}
/** @type {Promise<void> | null} */ let $c0a7c6fff4310ada$var$loading = null;
function $c0a7c6fff4310ada$export$1259559fefbb46c() {
    if ($c0a7c6fff4310ada$var$loading) return $c0a7c6fff4310ada$var$loading;
    $c0a7c6fff4310ada$var$loading = new Promise((resolve)=>{
        if (window.netlifyIdentity) return resolve();
        const script = document.createElement('script');
        script.src = 'https://identity.netlify.com/v1/netlify-identity-widget.js';
        script.async = true;
        script.addEventListener('load', ()=>{
            $c0a7c6fff4310ada$export$8c53c87b78e6fdd9();
            resolve();
        });
        // Ad blockers and offline both land here. Callers degrade rather than hang.
        script.addEventListener('error', ()=>resolve());
        document.head.appendChild(script);
    });
    return $c0a7c6fff4310ada$var$loading;
}
function $c0a7c6fff4310ada$export$267690839c122cee() {
    if (!$c0a7c6fff4310ada$export$d42ad5fbe912eace()) return Promise.resolve();
    return $c0a7c6fff4310ada$export$1259559fefbb46c();
}

});

parcelRegister("egRyG", function(module, exports) {

$parcel$export(module.exports, "uploadToCloudinary", () => $a63c1aeba6c78780$export$ba8726098bbb8aef);
/**
 * media.js — uploading to Cloudinary, signed.
 *
 * Previously each page built its own FormData with `upload_preset` read from
 * `process.env.CLOUDINARY_UPLOAD_PRESET`. Parcel inlines those values at build
 * time, so the preset and cloud name were literals in the public bundles —
 * enough for anyone to upload to this Cloudinary account from anywhere, with no
 * sign-in required.
 *
 * Now the browser holds no upload credential at all. It asks the server for a
 * one-shot signature, which requires a valid session, and sends that instead.
 */ 
var $36CJS = parcelRequire("36CJS");
async function $a63c1aeba6c78780$export$ba8726098bbb8aef(file) {
    const { cloudName: cloudName, apiKey: apiKey, timestamp: timestamp, signature: signature } = await (0, $36CJS.api).uploads.signature();
    const fd = new FormData();
    fd.append('file', file);
    fd.append('api_key', apiKey);
    fd.append('timestamp', timestamp);
    fd.append('signature', signature);
    const res = await fetch(`https://api.cloudinary.com/v1_1/${cloudName}/auto/upload`, {
        method: 'POST',
        body: fd
    });
    if (!res.ok) {
        const detail = await res.json().catch(()=>({}));
        throw new Error(detail?.error?.message || `Upload failed (${res.status})`);
    }
    return res.json();
}

});

parcelRegister("aSNdN", function(module, exports) {

$parcel$export(module.exports, "lightbox", () => $7ec520e42d422785$export$c2b330519424b9e8);
// Minimal single-image lightbox — click a post/reply photo to view it full-size.
// Self-contained: injects its own styles and DOM on first use.
//
// Built on <dialog>. The previous version was a div with role="dialog" and
// aria-modal="true", which promises behaviour the browser then has to be told
// to provide: focus stayed on the page behind, Tab walked straight out of the
// open lightbox, and nothing restored focus on close. showModal() gives all of
// that — the focus trap, the inert background, the ::backdrop and Escape — from
// the platform, and deletes the code that was half-implementing it.
/** @type {HTMLDialogElement | null} */ let $7ec520e42d422785$var$dialog = null;
let $7ec520e42d422785$var$imgEl, $7ec520e42d422785$var$captionEl;
function $7ec520e42d422785$var$ensureBuilt() {
    if ($7ec520e42d422785$var$dialog) return;
    const style = document.createElement('style');
    style.textContent = `
    .sa-lightbox {
      border: 0;
      padding: 2em 1em;
      max-width: 100vw;
      max-height: 100vh;
      width: 100%;
      height: 100%;
      background: transparent;
      overflow: hidden;
    }
    /* <dialog> is display:none until open, so this replaces the old
       .active class entirely \u{2014} the open state is now the element's own. */
    .sa-lightbox[open] {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .sa-lightbox::backdrop {
      background: rgba(0, 0, 0, 0.9);
    }
    .sa-lightbox img {
      max-width: 100%;
      max-height: 85vh;
      object-fit: contain;
      display: block;
      border-radius: var(--radius, 4px);
    }
    .sa-lightbox-caption {
      color: rgba(255, 255, 255, 0.7);
      font-size: 0.85em;
      text-align: center;
      margin-block-start: 0.75em;
    }
    .sa-lightbox-close {
      position: absolute;
      top: 1em;
      right: 1em;
      background: rgba(255, 255, 255, 0.1);
      border: 1px solid rgba(255, 255, 255, 0.3);
      color: white;
      width: 2.25em;
      height: 2.25em;
      border-radius: 50%;
      font-size: 1.1rem;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .sa-lightbox-close:hover { background: rgba(255, 255, 255, 0.2); }
    .sa-lightbox-figure { display: flex; flex-direction: column; align-items: center; max-width: 100%; }
  `;
    document.head.appendChild(style);
    $7ec520e42d422785$var$dialog = document.createElement('dialog');
    $7ec520e42d422785$var$dialog.className = 'sa-lightbox';
    $7ec520e42d422785$var$dialog.setAttribute('aria-label', 'Media viewer');
    $7ec520e42d422785$var$dialog.innerHTML = `
    <button class="sa-lightbox-close" aria-label="Close">\u{2715}</button>
    <figure class="sa-lightbox-figure">
      <img alt="">
      <figcaption class="sa-lightbox-caption"></figcaption>
    </figure>
  `;
    document.body.appendChild($7ec520e42d422785$var$dialog);
    $7ec520e42d422785$var$imgEl = $7ec520e42d422785$var$dialog.querySelector('img');
    $7ec520e42d422785$var$captionEl = $7ec520e42d422785$var$dialog.querySelector('.sa-lightbox-caption');
    $7ec520e42d422785$var$dialog.querySelector('.sa-lightbox-close').addEventListener('click', $7ec520e42d422785$var$close);
    // Click-outside-to-close. The dialog fills the viewport so that its
    // ::backdrop can be styled, which means "outside" is the dialog's own
    // padding — anything that is not the figure or the close button.
    $7ec520e42d422785$var$dialog.addEventListener('click', (event)=>{
        if (event.target === $7ec520e42d422785$var$dialog) $7ec520e42d422785$var$close();
    });
    // Escape is handled by the browser, which fires 'cancel' then 'close'. The
    // scroll lock is released in the 'close' handler so it lifts however the
    // dialog was dismissed.
    $7ec520e42d422785$var$dialog.addEventListener('close', ()=>{
        document.body.style.overflow = '';
    });
}
/**
 * @param {string} src
 * @param {string} [caption]
 */ function $7ec520e42d422785$var$open(src, caption = '') {
    $7ec520e42d422785$var$ensureBuilt();
    $7ec520e42d422785$var$imgEl.src = src;
    $7ec520e42d422785$var$imgEl.alt = caption;
    $7ec520e42d422785$var$captionEl.textContent = caption;
    $7ec520e42d422785$var$dialog.showModal();
    document.body.style.overflow = 'hidden';
}
function $7ec520e42d422785$var$close() {
    if ($7ec520e42d422785$var$dialog?.open) $7ec520e42d422785$var$dialog.close();
}
const $7ec520e42d422785$export$c2b330519424b9e8 = {
    open: $7ec520e42d422785$var$open,
    close: $7ec520e42d422785$var$close
};

});


var $3qsiv = parcelRequire("3qsiv");

var $aEIUa = parcelRequire("aEIUa");

var $fUvr1 = parcelRequire("fUvr1");
// Self-injecting "New Post" dialog for the feed page — same architecture as
// AuthModal (src/js/auth-modal.js): a singleton that injects its own markup
// into <body> once, then exposes open()/close(). Uses the native <dialog>
// element so focus-trapping, Escape handling, and the ::backdrop are all
// handled by the browser rather than hand-rolled.

var $gv1ku = parcelRequire("gv1ku");
const $0eccd64bdeabced8$var$DIALOG_HTML = `
  <dialog id="post-composer-dialog" aria-labelledby="composer-modal-title">
    <div class="composer-modal-header">
      <h2 id="composer-modal-title">New Post</h2>
      <button type="button" class="composer-modal-close" id="composer-modal-close" aria-label="Close">\u{2715}</button>
    </div>
    <div class="composer">
      <form id="post-form">
        <label for="post-title">Title (optional)</label>
        <input type="text" id="post-title" name="title" placeholder="Leave blank to post without a title">
        <label for="post-body">Body *</label>
        <div class="composer-toolbar">
          <button type="button" class="btn btn-sm" id="insert-link-btn">\u{1F517} Insert Link</button>
          <button type="button" class="btn btn-sm" id="insert-readmore-btn">\u{2702} Insert Read More Break</button>
        </div>
        <p class="composer-hint">Everything above the break shows in the feed; readers click "Read more" to see the rest.</p>
        <div id="link-insert-panel" hidden class="link-insert-panel">
          <label for="link-text-input">Link text</label>
          <input type="text" id="link-text-input" placeholder="e.g. Get tickets">
          <label for="link-url-input">URL</label>
          <input type="url" id="link-url-input" placeholder="https://\u{2026}">
          <div class="link-insert-actions">
            <button type="button" class="btn btn-sm" id="link-insert-confirm">Insert</button>
            <button type="button" class="btn btn-sm" id="link-insert-cancel">Cancel</button>
          </div>
          <p id="link-insert-status" class="link-insert-status"></p>
        </div>
        <textarea id="post-body" name="body" placeholder="What's happening with the band?" required></textarea>
        <label for="post-image">Photo / Video / Audio (optional)</label>
        <input type="file" id="post-image" name="image" accept="image/*,video/*,audio/*">
        <div id="image-preview-wrap" hidden>
          <div id="preview-media"></div>
          <button type="button" id="remove-image-btn" aria-label="Remove media">\u{2715}</button>
        </div>
        <p id="upload-status" aria-live="polite"></p>
        <button type="submit" class="btn" id="submit-btn">Publish Post</button>
        <p id="status-msg" role="status" aria-live="polite"></p>
      </form>
    </div>
  </dialog>
`;
// How long the "✓ Post published!" / "📱 Saved offline" message stays visible
// before the dialog auto-closes — mirrors the gallery upload modal's timing
// (src/js/gallery.js's handleUpload: setTimeout(closeUploadModal, 1200)).
const $0eccd64bdeabced8$var$AUTO_CLOSE_DELAY_MS = 1200;
class $0eccd64bdeabced8$var$PostComposerModal {
    constructor(){
        this._publishedHandlers = [];
        this._setupDOM();
    }
    _setupDOM() {
        document.body.insertAdjacentHTML('beforeend', $0eccd64bdeabced8$var$DIALOG_HTML);
        this.dialog = document.getElementById('post-composer-dialog');
        this._composer = (0, $gv1ku.initPostComposerForm)({
            onPublished: (post)=>this._handlePublished(post),
            onQueuedOffline: (record)=>this._handleQueuedOffline(record)
        });
        document.getElementById('composer-modal-close').addEventListener('click', ()=>this.requestClose());
        // Backdrop click: a click that lands outside the dialog's own box still
        // dispatches to the dialog element itself (::backdrop isn't a real
        // hit-testable node), so a bounding-rect check tells backdrop clicks
        // apart from clicks on the dialog's own padding.
        this.dialog.addEventListener('click', (e)=>{
            if (e.target !== this.dialog) return;
            const rect = this.dialog.getBoundingClientRect();
            const insideDialog = e.clientX >= rect.left && e.clientX <= rect.right && e.clientY >= rect.top && e.clientY <= rect.bottom;
            if (!insideDialog) this.requestClose();
        });
        // Escape fires 'cancel' before 'close' — intercept so an in-progress
        // draft gets the same discard confirmation as the close button, instead
        // of the browser silently closing the dialog out from under the author.
        this.dialog.addEventListener('cancel', (e)=>{
            e.preventDefault();
            this.requestClose();
        });
    }
    open() {
        this.dialog.showModal();
        document.body.style.overflow = 'hidden';
        document.getElementById('post-title')?.focus();
    }
    /** Close, but confirm first if the author has unsaved title/body/media. */ requestClose() {
        if ((0, $gv1ku.hasDraftContent)() && !confirm('Discard this post? Your draft will be lost.')) return;
        this._composer?.reset();
        this._close();
    }
    _close() {
        if (!this.dialog.open) return;
        this.dialog.close();
        document.body.style.overflow = '';
    }
    _handlePublished(post) {
        this._publishedHandlers.forEach((fn)=>fn(post, {
                pending: false
            }));
        setTimeout(()=>this._close(), $0eccd64bdeabced8$var$AUTO_CLOSE_DELAY_MS);
    }
    _handleQueuedOffline(record) {
        this._publishedHandlers.forEach((fn)=>fn(record, {
                pending: true
            }));
        setTimeout(()=>this._close(), $0eccd64bdeabced8$var$AUTO_CLOSE_DELAY_MS);
    }
    /**
   * Register a callback for when a post is published or queued offline.
   * @param {(post: object, meta: { pending: boolean }) => void} fn
   */ onPublished(fn) {
        this._publishedHandlers.push(fn);
    }
}
const $0eccd64bdeabced8$export$d9db653e95528a47 = new $0eccd64bdeabced8$var$PostComposerModal();



var $gv1ku = parcelRequire("gv1ku");

var $36CJS = parcelRequire("36CJS");
const $88eb302b374ce1d5$var$feed = document.getElementById('posts-feed');
const $88eb302b374ce1d5$var$loading = document.getElementById('loading');
const $88eb302b374ce1d5$var$emptyState = document.getElementById('empty-state');
const $88eb302b374ce1d5$var$errorState = document.getElementById('error-state');
const $88eb302b374ce1d5$var$newPostBtn = document.getElementById('new-post-btn');
// ─── "+ New Post" button (feed-embedded composer) ──────────────────────────────
// Shown to any signed-in user — same UX-convenience gating used for the
// gallery upload button and the /app composer; the server still enforces
// ALLOWED_AUTHORS on the actual publish (netlify/functions/create-post.mjs).
function $88eb302b374ce1d5$var$initComposerButton() {
    function applyVisibility() {
        if ($88eb302b374ce1d5$var$newPostBtn) $88eb302b374ce1d5$var$newPostBtn.hidden = !(0, $fUvr1.isLoggedIn)();
    }
    applyVisibility();
    const identity = window.netlifyIdentity;
    if (identity) {
        identity.on('init', applyVisibility);
        identity.on('login', applyVisibility);
        identity.on('logout', applyVisibility);
    }
    window.addEventListener('auth-modal:login', applyVisibility);
    $88eb302b374ce1d5$var$newPostBtn?.addEventListener('click', ()=>(0, $0eccd64bdeabced8$export$d9db653e95528a47).open());
}
// Update (or remove) the "N posts queued" banner above the feed.
function $88eb302b374ce1d5$var$renderPendingNotice(count) {
    let notice = document.getElementById('pending-notice');
    if (count === 0) {
        notice?.remove();
        return;
    }
    if (!notice) {
        notice = document.createElement('p');
        notice.id = 'pending-notice';
        notice.className = 'pending-notice';
        $88eb302b374ce1d5$var$feed.before(notice);
    }
    notice.textContent = `${count} post${count > 1 ? 's' : ''} queued \u{2014} will publish when back online.`;
}
// Publishing (or offline-queuing) from the feed's own composer modal should
// show up immediately, the same way the gallery's upload modal prepends a
// new item to the grid instead of waiting on a refetch.
(0, $0eccd64bdeabced8$export$d9db653e95528a47).onPublished((post, { pending: pending } = {})=>{
    $88eb302b374ce1d5$var$emptyState.hidden = true;
    if (pending) {
        $88eb302b374ce1d5$var$feed.insertBefore((0, $fUvr1.renderPost)({
            ...post.data,
            id: post.id,
            createdAt: post.createdAt
        }, {
            pending: true
        }), $88eb302b374ce1d5$var$feed.firstChild);
        $88eb302b374ce1d5$var$renderPendingNotice($88eb302b374ce1d5$var$feed.querySelectorAll('[data-pending-id]').length);
    } else $88eb302b374ce1d5$var$feed.insertBefore((0, $fUvr1.renderPost)(post), $88eb302b374ce1d5$var$feed.firstChild);
});
// ─── Pending-posts banner (offline queue) ─────────────────────────────────────
async function $88eb302b374ce1d5$var$showPendingPosts() {
    let db;
    try {
        db = await $88eb302b374ce1d5$var$openDB();
    } catch  {
        return; // IndexedDB unavailable — skip silently
    }
    const pending = await $88eb302b374ce1d5$var$getAllPending(db);
    if (!pending.length) return;
    $88eb302b374ce1d5$var$renderPendingNotice(pending.length);
    // Render each queued post as a greyed-out optimistic card
    for (const record of pending)$88eb302b374ce1d5$var$feed.insertBefore((0, $fUvr1.renderPost)({
        ...record.data,
        id: record.id,
        createdAt: record.createdAt
    }, {
        pending: true
    }), $88eb302b374ce1d5$var$feed.firstChild);
}

// ─── Service Worker registration + messages ────────────────────────────────────
// Registers the SW so the feed benefits from its stale-while-revalidate /api/
// caching (instant repaint on repeat visits) even for visitors who land here
// without ever going through /app first.
function $88eb302b374ce1d5$var$registerServiceWorker() {
    if (!('serviceWorker' in navigator)) return;
    navigator.serviceWorker.register((parcelRequire("70R4S")), {
        scope: '/'
    }).then((reg)=>(0, $gv1ku.syncQueuedPostsIfOnline)(reg)).catch((err)=>console.warn('[posts] SW registration failed:', err));
}
function $88eb302b374ce1d5$var$listenForSWMessages() {
    if (!('serviceWorker' in navigator)) return;
    navigator.serviceWorker.addEventListener('message', (e)=>{
        const { type: type, postId: postId, post: post, url: url } = e.data || {};
        if (type === 'POST_SYNCED') {
            // Replace the pending card with the real published post
            const pendingCard = $88eb302b374ce1d5$var$feed.querySelector(`[data-pending-id="${postId}"]`);
            if (pendingCard && post) pendingCard.replaceWith((0, $fUvr1.renderPost)(post));
            else if (pendingCard) pendingCard.remove();
            // Update (or remove) the notice to match however many pending cards remain
            $88eb302b374ce1d5$var$renderPendingNotice($88eb302b374ce1d5$var$feed.querySelectorAll('[data-pending-id]').length);
        }
        // The SW revalidated /api/get-posts in the background and found the
        // response actually changed — silently re-render instead of leaving
        // stale content on screen until the user manually reloads.
        if (type === 'API_UPDATED' && url?.includes('/api/get-posts')) $88eb302b374ce1d5$var$refreshPostsSilently();
    });
}
// ─── Silent background refresh ─────────────────────────────────────────────────
async function $88eb302b374ce1d5$var$refreshPostsSilently() {
    try {
        const posts = await (0, $36CJS.api).posts.list();
        await (0, $fUvr1.loadMyLikes)(); // like counts/state may have moved too
        // Replace only published cards — leave any pending (offline-queued) ones
        $88eb302b374ce1d5$var$feed.querySelectorAll('.post-card:not([data-pending-id])').forEach((el)=>el.remove());
        if (posts.length === 0 && !$88eb302b374ce1d5$var$feed.querySelector('[data-pending-id]')) $88eb302b374ce1d5$var$emptyState.hidden = false;
        else {
            $88eb302b374ce1d5$var$emptyState.hidden = true;
            posts.forEach((post)=>$88eb302b374ce1d5$var$feed.appendChild((0, $fUvr1.renderPost)(post)));
        }
    } catch (err) {
        console.warn('[posts] refreshPostsSilently error:', err);
    }
}
// ─── Load published posts from API ───────────────────────────────────────────
async function $88eb302b374ce1d5$var$loadPosts() {
    const settled = (0, $aEIUa.loadingIndicator)($88eb302b374ce1d5$var$loading);
    try {
        const posts = await (0, $36CJS.api).posts.list();
        settled();
        if (posts.length === 0 && !$88eb302b374ce1d5$var$feed.querySelector('[data-pending-id]')) {
            $88eb302b374ce1d5$var$emptyState.hidden = false;
            return;
        }
        posts.forEach((post)=>$88eb302b374ce1d5$var$feed.appendChild((0, $fUvr1.renderPost)(post)));
    } catch  {
        settled();
        // Only show error state if we have nothing else to display
        if (!$88eb302b374ce1d5$var$feed.children.length) $88eb302b374ce1d5$var$errorState.hidden = false;
    }
}
// ─── IndexedDB helpers (page context) ────────────────────────────────────────
function $88eb302b374ce1d5$var$openDB() {
    return new Promise((resolve, reject)=>{
        const req = indexedDB.open('SlingsArrows', 1);
        req.onerror = ()=>reject(req.error);
        req.onsuccess = ()=>resolve(req.result);
        req.onupgradeneeded = (e)=>{
            const db = e.target.result;
            if (!db.objectStoreNames.contains('pending-posts')) db.createObjectStore('pending-posts', {
                keyPath: 'id'
            });
        };
    });
}
function $88eb302b374ce1d5$var$getAllPending(db) {
    return new Promise((resolve, reject)=>{
        const tx = db.transaction([
            'pending-posts'
        ], 'readonly');
        const req = tx.objectStore('pending-posts').getAll();
        req.onerror = ()=>reject(req.error);
        req.onsuccess = ()=>resolve(req.result || []);
    });
}
// ─── Init ─────────────────────────────────────────────────────────────────────
(async ()=>{
    await (0, $3qsiv.ensureFreshSession)(); // refresh an expired session before any auth checks below
    (0, $3qsiv.initAuthBar)();
    $88eb302b374ce1d5$var$initComposerButton();
    $88eb302b374ce1d5$var$registerServiceWorker();
    $88eb302b374ce1d5$var$listenForSWMessages();
    (0, $gv1ku.retryQueuedPostsOnReconnect)();
    await (0, $fUvr1.loadMyLikes)(); // resolve like state before rendering post cards
    await $88eb302b374ce1d5$var$showPendingPosts(); // show offline queue before network posts load
    await $88eb302b374ce1d5$var$loadPosts();
})();


//# sourceMappingURL=feed.6a1c46dc.js.map
